import { render, staticRenderFns } from "./Chronic.vue?vue&type=template&id=960e7704"
import script from "./Chronic.vue?vue&type=script&lang=js"
export * from "./Chronic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports